import { UiStatistics } from "@app/performance/ui-statistics/UiStatistics";
import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "../shared/ErrorPages";
import { Roles, UserContext } from "../user";
import { JobStatistics } from "./job-statistics/JobStatistics";
import { PerformanceDashboard } from "./PerformanceDashboard";

export const PerformanceRouter: React.FC<React.PropsWithChildren<RouteComponentProps>> = () => {
  const user = React.useContext(UserContext);

  if (!user || !(
    user.roles.includes(Roles.PERFORMANCE_MONITOR)
  )) {
    return <NotFound />;
  }

  return (
    <Switch>
      <Route path="/performance/dashboard" component={PerformanceDashboard} />
      <Route path="/performance/ui-statistics" component={UiStatistics} />
      <Route path="/performance/job-statistics" component={JobStatistics} />
    </Switch>
  );
}
